module.exports = __webpack_public_path__ + "static/remove_access_form_2-b7ff3d7701038dbe5a09993b6ee29c55.png";